<app-driveb-master-wrapper>
  <div class="dialog-header first">
    <button
      class="close-button relative"
      mat-icon-button
      tabindex="-1"
      cdkFocusInitial
      (click)="closeDialog(false)"
      id="budgetModal-header-button-close"
    >
      <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
    </button>
  </div>
  <div class="dialog-content">
    <div class="margin-header">
      <h3 translate>add-budget-part</h3>
      <div
        *ngIf="!data.isFee && !isCarWorkshopLogged()"
        class="margin-container"
      >
        <label class="margin-label">{{ "label-margin" | translate }}:</label>
        <div class="margin-input-wrapper">
          <input
            type="text"
            [(ngModel)]="partMarginPercentage"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onPartMarginChange($event)"
            (blur)="formatMarginValue('part')"
            placeholder="0"
            id="budgetModal-form-input-partMargin"
            class="margin-input"
          />
          <span class="margin-percent-symbol">%</span>
        </div>
      </div>
    </div>
    <!-- Part data-->
    <form [formGroup]="partPriceForm" id="budgetModal-body-form-partPriceForm">
      <div class="row">
        <div class="col-4 col-information">
          <mat-form-field>
            <mat-label>{{ "input-manufacturer" | translate }}</mat-label>
            <input
              formControlName="partManufacturerName"
              matInput
              id="budgetModal-form-input-manufacturerName"
              (change)="handleManufacturerChange($event)"
              required
            />
            <mat-error
              translate
              *ngIf="getFormControls.partManufacturerName.hasError('required')"
              >required-manufacturer</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-3 col-information">
          <mat-form-field>
            <mat-label>{{ "input-part-code" | translate }}</mat-label>
            <input
              formControlName="partCode"
              matInput
              maxlength="30"
              id="budgetModal-form-input-partCode"
            />
          </mat-form-field>
        </div>
        <div class="col-5 col-information">
          <mat-form-field>
            <mat-label>{{ "input-part-name" | translate }}</mat-label>
            <input
              formControlName="partName"
              matInput
              (change)="handlePartNameChange()"
              id="budgetModal-form-input-partName"
              required
              maxlength="255"
            />
            <mat-error
              translate
              *ngIf="getFormControls.partName.hasError('required')"
              >required-part</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-4 col-information">
          <div>
            <app-smartfleet-measurement-unit-auto-complete
              class="mat-form-field"
              [required]="true"
              (onChange)="handleUnitChange($event)"
              #measurementUnitAutocomplete
              id="budgetModal-form-autoComplete-measurementUnit"
            >
            </app-smartfleet-measurement-unit-auto-complete>
          </div>
        </div>
        <div class="col-4 col-information">
          <mat-form-field>
            <mat-label>{{ labelPartCarWorkshopPrice }}</mat-label>
            <input
              formControlName="carWorkshopPrice"
              type="text"
              inputmode="decimal"
              matInput
              (input)="handlePartCarWorkshopPrice($event)"
              id="budgetModal-form-input-carWorkshopPrice"
              required
            />
            <mat-error
              translate
              *ngIf="
                partPriceForm.controls.carWorkshopPrice.hasError('required')
              "
              >required-price</mat-error
            >
            <mat-error
              translate
              *ngIf="
                partPriceForm.controls.carWorkshopPrice.hasError('minValue')
              "
              >min-value-greater-than-zero</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-4 col-information" *ngIf="!isCarWorkshopLogged()">
          <mat-form-field>
            <mat-label>{{ labelPartClientPrice }}</mat-label>
            <input
              formControlName="clientPrice"
              type="text"
              inputmode="decimal"
              matInput
              (input)="handlePartClientPrice($event)"
              id="budgetModal-form-input-clientPrice"
              required
            />
            <mat-error
              translate
              *ngIf="getFormControls.clientPrice.hasError('required')"
              >required-price</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-4 col-information">
          <mat-form-field>
            <mat-label>{{ "input-part-amount" | translate }}</mat-label>
            <input
              formControlName="partAmount"
              id="budgetModal-form-input-partAmount"
              matInput
              mask="separator.1"
              [dropSpecialCharacters]="false"
              [allowNegativeNumbers]="false"
              [thousandSeparator]="getThousandSeparator()"
              separatorLimit="1000000000000000000"
              required
            />
            <mat-error
              translate
              *ngIf="getFormControls.partAmount.hasError('required')"
              >required-amount</mat-error
            >
            <mat-error
              translate
              *ngIf="partPriceForm.controls.partAmount.hasError('min')"
              >min-value-greater-than-zero</mat-error
            >
          </mat-form-field>
        </div>
        <div
          class="col-4 col-information"
          *ngIf="!isCarWorkshopLogged() && isBrazilian"
        >
          <mat-form-field>
            <mat-label>PN ERP</mat-label>
            <input formControlName="pnErpCode" matInput />
          </mat-form-field>
        </div>

        <div class="col-4 col-information">
          <div
            class="display-slide-toggle"
            *ngIf="this.isBackofficesOrCarWorkshopLogged()"
          >
            <mat-slide-toggle formControlName="tire">
              {{ "toggle-tire" | translate }}
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      <div class="margin-header">
        <h3 translate>new-service</h3>
        <div
          *ngIf="!data.isFee && !isCarWorkshopLogged()"
          class="margin-container"
        >
          <label class="margin-label">{{ "label-margin" | translate }}:</label>
          <div class="margin-input-wrapper">
            <input
              type="text"
              [(ngModel)]="serviceMarginPercentage"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onServiceMarginChange($event)"
              (blur)="formatMarginValue('service')"
              placeholder="0"
              id="budgetModal-form-input-serviceMargin"
              class="margin-input"
            />
            <span class="margin-percent-symbol">%</span>
          </div>
        </div>
      </div>
      <!-- Service Data-->
      <div formGroupName="budgetServiceItem">
        <div class="row">
          <div class="col-6 col-information">
            <mat-form-field>
              <mat-label>{{ "input-service" | translate }}</mat-label>
              <input
                formControlName="serviceName"
                matInput
                id="budgetModal-form-input-serviceName"
                required
              />
              <mat-error
                translate
                *ngIf="
                  partPriceForm
                    .get('budgetServiceItem.serviceName')
                    .hasError('required')
                "
                >required-service</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-6 col-information">
            <mat-form-field>
              <mat-label>{{ labelServiceCarWorkshopPrice }}</mat-label>
              <input
                formControlName="carWorkshopPrice"
                type="text"
                inputmode="decimal"
                matInput
                (input)="handleServiceCarWorkshopPrice($event)"
                id="budgetModal-form-input-carWorkshopPrice"
                required
              />

              <mat-error
                translate
                *ngIf="
                  partPriceForm
                    .get('budgetServiceItem.carWorkshopPrice')
                    .hasError('required')
                "
                >required-price</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-information" *ngIf="!isCarWorkshopLogged()">
            <mat-form-field>
              <mat-label>{{ labelServiceClientPrice }}</mat-label>
              <input
                formControlName="clientPrice"
                type="text"
                inputmode="decimal"
                matInput
                (input)="handleServiceClientPrice($event)"
                id="budgetModal-form-input-clientPrice"
                required
              />
              <mat-error
                translate
                *ngIf="
                  partPriceForm
                    .get('budgetServiceItem.clientPrice')
                    .hasError('required')
                "
                >required-price</mat-error
              >
              <mat-error
                *ngIf="
                  partPriceForm
                    .get('budgetServiceItem.clientPrice')
                    .hasError('biggerOrEqual')
                "
                >{{ "required-bigger-or-equal" | translate }}
                {{ labelServiceCarWorkshopPrice }}</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-6 col-information">
            <mat-form-field>
              <mat-label>{{ "input-amount-hours" | translate }}</mat-label
              ><input
                formControlName="amountOfHours"
                type="hidden"
                id="budgetModal-form-input-amountOfHours"
              />

              <mat-select
                formControlName="selectedHours"
                matInput
                (selectionChange)="setHours($event)"
                [value]="selectedHours"
                id="budgetModal-form-select-selectedHours"
              >
                <mat-option *ngFor="let hour of hours" [value]="hour.value">
                  {{ hour.time }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6 col-information">
            <mat-form-field>
              <mat-label>{{ "input-amount-minutes" | translate }}</mat-label
              ><mat-select
                formControlName="selectedMinutes"
                matInput
                (selectionChange)="setMinutes($event)"
                [value]="selectedMinutes"
                id="budgetModal-form-select-selectedMinutes"
              >
                <mat-option
                  *ngFor="let minute of minutes"
                  [value]="minute.value"
                >
                  {{ minute.time }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="toggles-grid">
        <div class="col-4 col-information">
          <div class="toggle-wrap">
            <mat-slide-toggle
              formControlName="guarantee"
              (change)="handleGuaranteeAndCourtesy($event)"
            >
              {{ "label-in-warranty" | translate }}
            </mat-slide-toggle>
          </div>
        </div>
        <div class="col-4 col-information">
          <div class="toggle-wrap">
            <mat-slide-toggle
              formControlName="courtesy"
              (change)="handleGuaranteeAndCourtesy($event)"
            >
              {{ "label-in-courtesy" | translate }}
            </mat-slide-toggle>
            <div class="overlay"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="dialog-actions">
    <button
      [disabled]="partPriceForm.invalid"
      mat-raised-button
      color="primary"
      (click)="closeDialog(true)"
      style="height: 49px"
      id="budgetModal-form-button-save"
    >
      {{ "input-save" | translate }}
    </button>
  </div>
</app-driveb-master-wrapper>
